import React, { useState } from 'react';

export const Footer: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    if (!email) {
      setSubmitStatus('error');
      setIsSubmitting(false);
      return;
    }

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5qlf1r592clg457kekg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    }

    setIsSubmitting(false);
  };

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">Apartment Buyers Direct</h3>
            <p className="text-gray-300 mb-4">
              We buy apartment buildings directly from owners across the nation. 
              Get a fair cash offer without repairs, fees, or long waiting periods.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">
              <a href="/sell-my-apartment-building" className="text-white hover:text-orange-300">Our Services</a>
            </h4>
            <ul className="space-y-3">
              <li><a href="/sell-my-apartment-building" className="text-gray-300 hover:text-orange-300 transition-colors">Sell Apartment Building</a></li>
              <li><a href="/we-buy-apartment-buildings" className="text-gray-300 hover:text-orange-300 transition-colors">We Buy Buildings</a></li>
              <li><a href="/apartment-building-valuation" className="text-gray-300 hover:text-orange-300 transition-colors">Property Valuation</a></li>
              <li><a href="/seller-financing-benefits" className="text-gray-300 hover:text-orange-300 transition-colors">Seller Financing</a></li>
              <li><a href="/how-it-works" className="text-gray-300 hover:text-orange-300 transition-colors">How It Works</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-lg font-semibold mb-6">
              <a href="/tips-for-selling-apartment-building" className="text-white hover:text-orange-300">Resources</a>
            </h4>
            <ul className="space-y-3">
              <li><a href="/tips-for-selling-apartment-building" className="text-gray-300 hover:text-orange-300 transition-colors">Selling Tips</a></li>
              <li><a href="/apartment-building-financial-terms" className="text-gray-300 hover:text-orange-300 transition-colors">Financial Terms</a></li>
              <li><a href="/sell-my-apartment-building/as-is-vs-remodel" className="text-gray-300 hover:text-orange-300 transition-colors">As-Is vs Remodel</a></li>
              <li><a href="/tips-for-selling-apartment-building/tenants-and-leases" className="text-gray-300 hover:text-orange-300 transition-colors">Tenants & Leases</a></li>
              <li><a href="/tips-for-selling-apartment-building/for-sale-by-owner" className="text-gray-300 hover:text-orange-300 transition-colors">For Sale By Owner</a></li>
              <li><a href="/how-it-works/selling-inherited-apartments" className="text-gray-300 hover:text-orange-300 transition-colors">Inherited Properties</a></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-700 bg-gray-900 py-6">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <div className="mb-4 md:mb-0">
              © 2024 SellApartmentsCash.com. All rights reserved.
            </div>
            <div className="flex items-center space-x-6">
              <a href="/privacy-and-terms" className="hover:text-orange-300 transition-colors">Privacy Policy and Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
